import '/assets/styles/sections/menu-header.scss';
import classNames from 'classnames';

// Context
import { useBranchSelection } from '/utilities/branch-selection';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';

// Partials
import { Input } from '/views/partials/forms';
import Btn from '/views/partials/btn';

// Sections
import PageHeader from '/views/sections/page-header';

const MenuHeader = ({
	searchValue,
	onSearchValueChange,
	backLinkRedirect,
	backLinkFallback,
	backLinkParams,
	backLink,
	hideSearch,
	autoFocus,
	title = 'Menü',
}) => {
	const { branchTableTitle } = useBranchSelection();
	const { redirect } = useNavigator();

	return (
		<div className="section menu-header">
			<PageHeader
				icon="menu"
				backLink={backLink ?? 'home'}
				backLinkParams={backLinkParams}
				backLinkRedirect={backLinkRedirect}
				backLinkFallback={backLinkFallback}
				title={title}
				backLinkText
				subtitle={branchTableTitle}
			/>
			{!hideSearch && (
				<div className="header-search">
					<div className="wrapper">
						<Input
							autoFocus={!!searchValue || autoFocus}
							icon="search"
							placeholder="Ne yemek istersin?"
							type="text"
							innerContent={
								!!searchValue && (
									<Btn
										icon="close"
										onClick={() => {
											onSearchValueChange('');
										}}
										className={classNames('header-clearbtn', 'rounded', {
											show: !!searchValue?.length,
										})}
										title="Temizle"
									/>
								)
							}
							value={searchValue}
							onChange={onSearchValueChange}
							onClick={
								onSearchValueChange
									? undefined
									: () => {
											redirect('menuSearch');
										}
							}
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default MenuHeader;
